<template>
    <div id="app">
        <v-container fluid pa-0>
            <v-layout row wrap>
                <v-flex md2 xs12 pa-0 pr-3 pl-3>
                    <v-card flat dark color="transparent">
                        <Sports @setSport="selectSport" :connection="connection"></Sports>
                    </v-card>
                </v-flex>
                <v-flex md7 xs12 pa-0 class="full-height">
                    <v-card flat color="grey darken-3">
                        <v-card-text class="px-0 py-0">
                            <BetOptions v-on:childToParent="onChildClick" :sport="sport" :connection="connection"></BetOptions>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex md3 xs12 pa-0 pl-3 pr-3>
                    <v-card flat dark color="transparent">
                        <!--<Widget></Widget>-->
                        <!--<Statscore :eventObject="fromChild"></Statscore>-->
                        <BetSlip :eventObject="fromChild" :connection="connection"></BetSlip>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import Sports from './components/Sports.vue';
    import Widget from './components/Widget.vue';
    import BetSlip from './components/BetSlip.vue';
    import BetOptions from './components/BetOptions.vue';
    import Statscore from './components/Statscore.vue';
    import { HubConnectionBuilder } from "@aspnet/signalr";
    import { setInterval } from 'timers';
    import * as CONFIG from './config'

    export default {
        name: 'app',
        components: {
            Sports,
            Widget,
            BetSlip,
            BetOptions,
            Statscore
        },
        data() {
            return {
                connection: null,
                sport: '',
                fromChild: null,
                polling: null,
            }
        },
        methods: {
            onChildClick(value) {
                this.fromChild = value
            },
            selectSport: function (selectedSport) {
                this.sport = selectedSport;
            },
            pollAccessToken() {
                try {
                    let { query, fullPath } = this.$route
                    if (query && query.token) {
                        this.$store.dispatch('login', { authToken: query.token });
                    } else if (fullPath && fullPath.includes('?token=')) {
                        const token = fullPath.substring(fullPath.indexOf('=') + 1);
                        this.$store.dispatch('login', { authToken: token });
                    }
                } catch (error) {
                    console.error(error);
                }

                setInterval(() => {
                    // if the user has a token - and 20 minutes has passed - renew the token.
                    if (this.$store.getters.accessToken) {
                        this.$store.dispatch('login', { authToken: this.$store.getters.accessToken });
                    }
                }, 1200000)
            },
            startConnection() {
                this.connection
                    .start()
                    .then(() => {
                        console.log('SignalR connection started');
                    })
                    .catch((err) => {
                        console.error('Error starting SignalR connection:', err);
                    });
            },

            setupConnectionMonitor() {
                setInterval(() => {
                    if (this.connection.state != 1) {
                        console.log('SignalR connection is disconnected. Attempting to reconnect...');
                        this.startConnection();
                    }
                }, 5000);
            }

        },
        created() {
            this.pollAccessToken();
        },
        mounted() {
             const videojsscript = document.createElement('script');
                videojsscript.src = 'https://vjs.zencdn.net/7.17.0/video.min.js';
                videojsscript.async = true;
                videojsscript.addEventListener('load', () => {
                });
                document.body.appendChild(videojsscript);
                
            if (CONFIG.STATSCORE_WIDGET) {
                !function(){var d="STATSCOREWidgetsEmbederScript";if(!window.document.getElementById(d)){window.STATSCOREWidgets={},window.STATSCOREWidgets.onLoadCallbacks=[],window.STATSCOREWidgets.onLoad=function(d){window.STATSCOREWidgets.onLoadCallbacks.push(d)};var n=window.document.createElement("script");n.src="https://wgt-s3-cdn.statscore.com/bundle/Embeder.js",n.async=!0,n.id=d,n.addEventListener("error",function(d){for(var n=0;n<window.STATSCOREWidgets.onLoadCallbacks.length;n++)window.STATSCOREWidgets.onLoadCallbacks[n](d)}),window.document.body.appendChild(n)}}();
            }
            this.connection = new HubConnectionBuilder()
                .withUrl(CONFIG.SIGNALR_HUB)
                .build();
            this.setupConnectionMonitor();
        },
        beforeDestroy() {
            this.connection.stop();
            clearInterval(this.polling);
        }
    };
</script>

<style>
    * {
        box-sizing: border-box;
    }

    html {
        overflow: scroll;
        overflow-x: hidden;
    }

    html, body {
        height: 100%;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    body {
        background-color: #000000;
        font-family: 'Roboto', Helvetica, Arial, sans-serif;
        margin-top: 10px;
    }


    .v-datatable__actions__select {
        display: none !important;
    }

    .application--wrap {
        min-height: inherit !important;
    }

    img, svg {
        max-width: 100%;
    }

    .application--wrap {
        min-height: 100% !important;
    }

    .v-tabs__slider.accent {
        border-color: #fff !important;
        background-color: #fff !important;
    }

    li.blue.darken-4 {
        background-color: #004369 !important;
    }

    ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background: #D3D3D3;
    }

    .odds-select .v-menu__content {
        top: 5px !important;
        left: 0px !important;
    }

    .success {
        background-color: #4caf50 !important;
        border-color: none;
        position: relative;
        height: 56px;
        z-index: 999;
        margin-top: 0px;
        margin-bottom: 15px;
        font-weight: 300;
        letter-spacing: 0.6px;
        font-size: 15px;
    }

    .error {
        background-color: #d70033 !important;
        border-color: #ff5252 !important;
        font-weight: 200;
        margin-bottom: 18px !important;
    }

    .v-alert {
        border-radius: 0;
        border-width: 0px 0 0;
    }

    .flex.md2.xs12.pa-0.pr-3.pl-3 {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .flex.md3.xs12.pa-0.pl-3.pr-3 {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    /*Styles Belong to BetOptions.vue STARTS*/
    .full-height {
        overflow-x: hidden;
        overflow-y: auto;
        height: 100vh;
        -ms-overflow-style: none;
    }

        /*.full-height::-webkit-scrollbar {
            width: 10px;
        }*/

        .full-height::-webkit-scrollbar {
            width: 15px; /* width of the entire scrollbar */
        }

        .full-height::-webkit-scrollbar-track {
            background: #232323; /* color of the tracking area */
        }

        .full-height::-webkit-scrollbar-thumb {
            background-color: #474747; /* color of the scroll thumb */
            border-radius: 3px; /* roundness of the scroll thumb */
            border: 1px solid #232323;
        }

    .purple.darken-4 > .v-expansion-panel__header {
        padding: 0px 0px;
        min-height: 35px !important;
        max-height: 35px;
    }

    .v-expansion-panel__header__icon {
        height: 35px;
        width: 35px;
        text-align: center;
        padding-top: 5px;
        position: absolute;
        right: 0px;
        top: 0px;
    }

    .v-expansion-panel__header {
        padding: 0px !important;
        min-height: 35px !important;
    }

    .info--text.v-btn {
        background-color: #272727 !important;
        margin: 0px !important;
    }

    .v-btn.v-btn--flat.theme--dark.info--text.threeMarkets.threeMarkets {
        width: 33.3% !important;
        border: white 0px solid !important;
    }

    .v-btn.v-btn--flat.theme--dark.info--text.twoMarkets {
        width: 50% !important;
    }

    .v-btn__content {
        display: flex !important;
    }

    .odd {
        color: #f4ea22 !important;
        display: inline-block;
        width: 71px !important;
        background-color: #424242;
        position: relative;
        right: auto;
        top: -14px;
        height: 36px !important;
        padding-top: 9px;
        font-size: 14px;
        text-align: right;
        padding-right: 0px;
        min-width: 70px;
        padding-left: 10px;
        padding-right: 10px;
        border-bottom: 1px solid #000 !important;
        margin-right: -1px;
    }

    @-moz-document url-prefix() {
        .marketName {
            overflow: visible !important;
        }

        .odd {
            top: 0px;
        }

        @media (max-width: 1024px) {
            .odd {
                top: 0px !important;
            }
        }
    }

    .marketName {
        width: calc(100% - 70px) !important;
        display: inline-block !important;
        padding-top: 9px !important;
        padding-bottom: 9px;
        font-size: 14px !important;
        text-align: left !important;
        text-transform: capitalize;
        padding-left: 10px;
        border-bottom: 1px solid #000 !important;
        background-color: #2b2b2b;
        height: 36px;
        padding-right: 10px;
    }

    button.v-btn.v-btn--flat.theme--dark.info--text.v-btn--active.twoMarkets .marketName {
        background-color: #020381 !important;
    }

    .v-btn-toggle .v-btn {
        padding: 0 0px !important;
    }

    .v-btn-toggle.markets {
        font-size: 16px !important;
        background-color: #696969 !important;
    }

    .lock {
        color: #181818 !important;
        display: inline-block;
        width: 70px !important;
        background-color: #424242;
        position: absolute !important;
        right: -1px;
        top: 0px;
        height: 36px !important;
        padding-top: 9px;
        font-size: 14px;
        text-align: right;
        padding-right: 10px;
        padding-top: 11px;
    }

    .threeMarkets.disabledMarket {
        background-color: #272727 !important;
        opacity: 1 !important;
    }

    .v-btn-toggle .v-btn:last-child {
        border-radius: 0 0px 0px 0 !important;
        left: 0px;
    }

    .v-expansion-panel__header {
        border-bottom: 1px solid #000;
    }

        .v-expansion-panel__header .game-header-title:last-child {
            border-bottom: 0px solid #000 !important;
        }
    /*Styles Belong to BetOptions.vue ENDS*/
    /*Styles Belong to EventBetTypes.vue STARTS*/
    .mb-0.market-inner .marketTextholder .odd {
        border-bottom: 1px solid #000 !important;
    }

    .v-btn-toggle.markets:first-child {
        border-bottom: 0px !important;
        margin-bottom: -1px;
    }

    .v-expansion-panel {
        box-shadow: none !important;
        background-color: black;
    }

    .v-btn.v-btn--flat.theme--dark.info--text.v-btn--active.twoMarkets, .v-btn.v-btn--flat.theme--dark.info--text.v-btn--active.threeMarkets, .v-btn.v-btn--flat.theme--dark.info--text.v-btn--active {
        background-color: #020381 !important;
        border-right-color: transparent !important;
    }

        .v-btn.v-btn--flat.theme--dark.info--text.v-btn--active.twoMarkets .odd, .v-btn.v-btn--flat.theme--dark.info--text.v-btn--active.threeMarkets .odd, .v-btn.v-btn--flat.theme--dark.info--text.v-btn--active .odd {
            background-color: #f4ea22;
            color: #000000 !important;
        }

    .v-btn--active .marketName {
        background-color: #020381 !important;
    }

    .v-chip .v-chip__content {
        cursor: default;
        height: 43px !important;
        padding: 0 20px !important;
    }
    /*Styles Belong to EventBetTypes.vue ENDS*/
    /*Styles belong to MatchWinner.vue STARTS*/
    .disableText.marketName {
        color: #6a6868 !important;
        display: block !important;
    }

    .disabledMarket .marketTextholder .lock {
        border-bottom: 1px solid #000;
    }

    .disabledMarket .marketTextholder {
        border-bottom: 1px solid #000;
        height: 36px !important;
    }

    .disabledMarket {
        opacity: 1 !important;
    }

    .v-btn.v-btn--flat.theme--dark.info--text.twoMarkets.disabledMarket {
        width: 50% !important;
    }
    /*Styles belong to MatchWinner.vue ENDS*/
    /*Styles belong to BetSlip STARTS*/
    .v-card > :last-child:not(.v-btn):not(.v-chip) {
        border-bottom-left-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
    }

    .v-card > :first-child:not(.v-btn):not(.v-chip) {
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
    }

    .v-tabs__container--fixed-tabs .v-tabs__div {
        min-width: auto !important;
        max-width: 100% !important;
    }

    .v-tabs__container--fixed-tabs > .v-tabs__div:last-child {
        margin-right: 0px !important;
    }

    .v-tabs__container--fixed-tabs .v-tabs__slider-wrapper + .v-tabs__div {
        margin-left: 0px !important;
    }

    .v-tabs__container {
        height: 36px !important;
        border-radius: 0px !important;
    }

    .v-tabs__slider-wrapper {
        display: none !important;
    }

    .betslip-item-header {
        color: white;
        font-size: 14px !important;
        line-height: 17px;
        padding-left: 8px;
        text-align: left;
        padding-bottom: 1px;
        text-transform: capitalize !important;
        width: 100%;
        font-weight: 300 !important;
        padding-top: 5px;
    }

    .bet-winner-title {
        background-color: #020381;
        height: 32px;
        vertical-align: middle;
    }

    .theme--dark.v-text-field--box > .v-input__control > .v-input__slot {
        background: #191927 !important;
    }

    .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
        padding-bottom: 10px !important;
        padding-left: 10px !important;
        padding-right: 10px !important;
    }

    .theme--dark.v-input:not(.v-input--is-disabled) input {
        color: #fff;
        border: 1px solid #948c8c;
        background-color: #020381;
        margin-top: 34px;
        font-weight: normal;
        padding-left: 5px;
    }


    .theme--dark.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
        border: 0px !important;
    }

    .v-text-field--box .v-label--active {
        transform: none !important;
    }

    .border .v-text-field__slot input {
        margin-top: 10px !important;
        max-height: 30px;
    }

    .v-text-field--box > .v-input__control > .v-input__slot {
        border-top-left-radius: 0px !important;
        border-top-right-radius: 0px !important;
    }

    .theme--dark.v-input--is-disabled .v-label, .theme--dark.v-input--is-disabled input {
        color: #fff !important;
    }

    .theme--dark.v-input--is-disabled input {
        border-bottom: 0px solid #948c8c;
        background-color: transparent;
        color: #f4ea22 !important;
    }

    .btn-submit {
        margin: 0px 0px 20px 0px;
        color: white;
        display: flex !important;
        margin: 16px auto !important;
        height: 40px !important;
        font-size: 18px !important;
        font-weight: 400 !important;
        width: 187px !important;
    }

        .btn-submit.v-btn.theme--dark.green {
            background-color: #f4ea22 !important;
            color: #020381 !important
        }

    .footer .v-label.v-label--active.theme--dark {
        color: #fff;
        font-size: 11px;
        padding: 12px 0px;
        padding-left: 40px !important;
        text-transform: capitalize;
        font-size: 15px;
        font-weight: 500;
        padding-left: 10px;
        background-color: #020381;
        /*position: relative !important;*/
        width: 100%;
        display: table;
        position: absolute !important;
        /*transform: none !important;*/
        /*top: -12px;*/
    }

    .v-input__prepend-outer {
        margin-right: 9px;
        position: absolute;
        top: 5px !important;
        z-index: 1;
        left: 10px !important;
    }

    .footer .v-input__append-inner {
        z-index: 1 !important;
        margin-left: auto !important;
        padding-left: 0px !important;
        align-self: auto !important;
    }

        .footer .v-input__append-inner .v-icon.material-icons.theme--dark {
            margin-top: -1px;
            margin-right: 30px;
            background-color: #020381;
            padding-top: 7px;
            padding-bottom: 7px;
            padding-left: 5px;
            padding-right: 5px;
            border: 1px solid #948c8c;
            border-left-width: 0px;
            transform: none;
        }

    .v-select__selection--comma {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: block !important;
        position: relative !important;
        margin-left: 10px !important;
        margin-top: 10px !important;
        margin-right: 20px !important;
        /*z-index: 10 !important;*/
        max-width: 100% !important;
        font-size: 13px;
        font-weight: 400;
        border: 1px solid #948c8c !important;
        background-color: #020381 !important;
        padding: 10px !important;
    }

    .footer .theme--dark.v-input:not(.v-input--is-disabled) input {
        margin-top: 0px !important;
        margin-bottom: 20px !important;
        margin-left: 10px;
        display: none !important;
    }

    .footer .theme--dark.v-text-field > .v-input__control > .v-input__slot:before {
        border-color: #2b2b2b !important;
    }

    .footer .v-select__selections {
        display: block !important;
    }

    .footer .v-text-field > .v-input__control > .v-input__slot:after {
        border-color: #2b2b2b !important;
        border-style: solid;
        border-width: thin 0;
        -webkit-transform: none !important;
        transform: none !important;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
        -webkit-transform: none !important;
        transform: none !important;
        border-color: #2b2b2b !important;
        border-width: 1px !important;
        border: none !important;
    }
    /*Styles belong to BetSlip ENDS*/
    /*Tablet Landscape Responsive Starts*/
    /*@media (max-width: 1024px) {
        .marketName {
            padding-top: 10px !important;
            font-size: 12px !important;
        }

        .odd {
            top: -15px;
            padding-top: 10px;
            font-size: 12px;
        }
    }*/

    @media (max-width: 959px) {
        .flex.md2.xs12.pa-0.pr-3.pl-3 {
            padding-left: 0px !important;
        }

        .flex.md3.xs12.pa-0.pl-3.pr-3 {
            padding-left: 0px !important;
            padding-right: 0px !important;
        }

        /*Sports Menu*/
        .v-list.py-0.borders.theme--dark {
            height: 100px; /* 40px - more place for scrollbar, is hidden under parent box */
            padding: 5px;
            white-space: nowrap;
            overflow-x: scroll;
            overflow-y: hidden !important;
            -webkit-overflow-scrolling: touch;
        }

        .sport-btn.px-0 {
            display: inline-block;
            width: auto;
            height: 70px;
            line-height: 50px;
            text-align: center;
            margin-top: 10px;
        }

            .sport-btn.px-0 + .sport-btn.px-0 {
                margin-left: 15px;
                margin-right: 15px;
            }

        .v-card div .borders .sport-btn .v-list__tile--avatar {
            border-bottom: 0px solid #36313b;
        }

        .v-list__tile {
            display: block !important;
        }

        .v-list__tile__title {
            text-align: center !important;
        }

        .selectedSport .v-list__tile__avatar {
            background-color: transparent;
        }

        .v-list__tile--avatar {
            padding: 0 0px !important;
        }

        .v-list__tile__avatar {
            background-color: transparent;
            text-align: center;
            display: inline-block !important;
        }

        .v-avatar {
            width: 50px !important;
            height: 50px !important;
            background-color: transparent !important;
        }

        .sport-btn:hover .sport-btn:active {
            background-color: transparent !important;
        }

        .v-list__tile__content {
            display: block !important;
            padding-left: 0px !important;
        }

        .v-list.py-0.borders.theme--dark .sport-btn.px-0:first-child {
            margin-left: 10px !important;
            margin-right: 10px !important;
        }

        .theme--dark.v-list .v-list__tile--link:hover {
            background: hsla(0,0%,100%,.00) !important;
        }

        ::-webkit-scrollbar-thumb {
            background: transparent !important;
        }
        /*Sports Menu Ends*/
        /*Betslip Sticky Starts*/
        .betslip-sticky {
            position: fixed;
            bottom: 0px;
            margin-bottom: 0px;
            margin-left: auto;
            margin-right: auto;
            text-align: left;
            align-items: center;
            width: 100%;
            z-index: 999;
            max-height: 400px;
            overflow: hidden auto;
            overflow-x: hidden;
            overflow-y: auto;
            display: block;
            -webkit-box-shadow: 0px -3px 4px 0px rgba(0,0,0,0.4);
            -moz-box-shadow: 0px -3px 4px 0px rgba(0,0,0,0.4);
            box-shadow: 0px -3px 4px 0px rgba(0,0,0,0.4);
            border-top: 1px solid #424242;
        }

            .betslip-sticky::-webkit-scrollbar-thumb {
                background-color: #474747 !important;
                border: 2px solid #474747;
            }

            .betslip-sticky::-webkit-scrollbar-track {
                box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
                background-color: #232323;
            }

            .betslip-sticky::-webkit-scrollbar {
                width: 10px;
                background-color: #d3d3d3;
            }

        .v-select__selection--comma {
            z-index: 1 !important;
        }

        .odds-select .v-menu__content {
            bottom: 5px !important;
            left: 0px !important;
            z-index: 1 !important;
            top: unset !important;
        }

        .upcoming-container {
            margin-bottom: 103px;
        }

        .v-menu__content.theme--light.v-menu__content--fixed.menuable__content__active {
            min-width: initial !important;
            width: 100% !important;
            margin: 0 auto !important;
            transform-origin: top center !important;
        }

        .v-btn {
            padding: 0 10px;
        }
        /*Betslip Sticky ENDS*/
    }
    /*Tablet Landscape Responsive ENDS*/
    /* Latest Media Queries For Responsive View Bryan */
    @media (max-width: 959px) {
        .flex.md6.xs12.pa-0.pr-3, .flex.md3.xs12.pa-0.pr-3 {
            padding-right: 0 !important;
        }

        .flex.md3.xs12.pa-0.pl-3, .flex.md3.xs12.pa-0.pl-3 {
            padding-left: 0px !important;
        }

        .betSlip button.btn-submit.v-btn.v-btn--disabled.theme--dark.blue--text .v-btn__content {
            white-space: nowrap !important;
        }

        .betSlip button.btn-submit.v-btn.theme--dark.blue .v-btn__content {
            white-space: nowrap !important;
        }
    }

    .betSlip .v-alert {
        width: 100%;
    }

    .tooltip {
        display: block !important;
        z-index: 10000;
    }

        .tooltip .tooltip-inner {
            background: black;
            color: white;
            border-radius: 16px;
            padding: 5px 10px 4px;
        }

        .tooltip .tooltip-arrow {
            width: 0;
            height: 0;
            border-style: solid;
            position: absolute;
            margin: 5px;
            border-color: black;
            z-index: 1;
        }

        .tooltip[x-placement^="top"] {
            margin-bottom: 5px;
        }

            .tooltip[x-placement^="top"] .tooltip-arrow {
                border-width: 5px 5px 0 5px;
                border-left-color: transparent !important;
                border-right-color: transparent !important;
                border-bottom-color: transparent !important;
                bottom: -5px;
                left: calc(50% - 5px);
                margin-top: 0;
                margin-bottom: 0;
            }

        .tooltip[x-placement^="bottom"] {
            margin-top: 5px;
        }

            .tooltip[x-placement^="bottom"] .tooltip-arrow {
                border-width: 0 5px 5px 5px;
                border-left-color: transparent !important;
                border-right-color: transparent !important;
                border-top-color: transparent !important;
                top: -5px;
                left: calc(50% - 5px);
                margin-top: 0;
                margin-bottom: 0;
            }

        .tooltip[x-placement^="right"] {
            margin-left: 5px;
        }

            .tooltip[x-placement^="right"] .tooltip-arrow {
                border-width: 5px 5px 5px 0;
                border-left-color: transparent !important;
                border-top-color: transparent !important;
                border-bottom-color: transparent !important;
                left: -5px;
                top: calc(50% - 5px);
                margin-left: 0;
                margin-right: 0;
            }

        .tooltip[x-placement^="left"] {
            margin-right: 5px;
        }

            .tooltip[x-placement^="left"] .tooltip-arrow {
                border-width: 5px 0 5px 5px;
                border-top-color: transparent !important;
                border-right-color: transparent !important;
                border-bottom-color: transparent !important;
                right: -5px;
                top: calc(50% - 5px);
                margin-left: 0;
                margin-right: 0;
            }

        .tooltip.popover .popover-inner {
            background: #f9f9f9;
            color: black;
            padding: 24px;
            border-radius: 5px;
            box-shadow: 0 5px 30px rgba(0,0,0, .1);
        }

        .tooltip.popover .popover-arrow {
            border-color: #f9f9f9;
        }

        .tooltip[aria-hidden='true'] {
            visibility: hidden;
            opacity: 0;
            transition: opacity .15s, visibility .15s;
        }

        .tooltip[aria-hidden='false'] {
            visibility: visible;
            opacity: 1;
            transition: opacity .15s;
        }

    @media (max-width:959px) {
        #app .container.fluid.pa-0 .layout.row.wrap .flex.md2.xs12.pa-0.pr-3 {
            padding-right: 0 !important;
        }
    }

    .full-white-border {
        border: 0px solid #fff;
    }

    .border .v-text-field .v-input__control {
        font-size: 14px;
    }

    .border .v-text-field__slot input {
        margin-top: 13px;
        max-height: 30px;
    }
    /*Mobile Responsive Starts*/
    @media (max-width:660px) {
        .v-btn.v-btn--flat.theme--dark.info--text.twoMarkets {
            width: 100% !important;
        }

        .v-btn.v-btn--flat.theme--dark.info--text.threeMarkets.threeMarkets {
            width: 100% !important;
        }

        .v-btn.v-btn--flat.theme--dark.info--text.twoMarkets.disabledMarket {
            width: 100% !important;
        }

        .v-tabs__item {
            flex: none !important;
        }
        /*Mobile Responsive ENDS*/
    }
    /*Mobile Portrait STARTS*/
    @media (max-width:480px) {
        .game-header-title {
            overflow: hidden;
            word-break: break-all;
            text-overflow: ellipsis;
            width: 100%;
            white-space: nowrap;
            font-size: 13px;
            min-width: 120px;
        }

            .game-header-title span {
                margin-top: -10px;
                font-size: 11px;
                min-width: 120px !important;
            }

        .tournament-title {
            font-size: 13px !important;
        }

        .market-status, .market-status-suspended, .marketHeader {
            font-size: 13px !important;
        }

        .marketHeader {
            padding-top: 9px !important;
            padding-bottom: 8px !important;
        }

        .v-chip .v-chip__content {
            padding: 0 10px !important;
        }

        .v-tabs__item {
            flex: none !important;
        }
    }
    /*Mobile Portrait Ends*/
    @-moz-document url-prefix() {
        .border .v-text-field__slot input {
            padding-top: 10px;
        }
    }

    .border .v-text-field .v-input__slot {
        min-height: 20px !important;
        border-bottom: 1px solid #453c52;
    }



    .border .v-text-field .v-label {
        font-size: 15px;
        color: #fff;
        font-weight: 300;
        top: 10px;
        float: left;
        width: 70% !important;
        display: inline !important;
        max-width: 70% !important;
        position: relative !important;
        padding-top: 5px;
        height: auto !important;
    }

    .v-text-field__slot input {
        -webkit-box-flex: initial;
        -ms-flex: 1 1 auto;
        flex: none;
        line-height: 20px;
        padding: 8px 0;
        max-width: 50%;
        min-width: 0;
        width: 30% !important;
        float: left !important;
        display: inline !important;
        max-width: 30% !important;
        position: relative !important;
        text-align: right !important;
        padding-top: 10px !important;
    }

    .footer .v-menu .v-select-list .v-list {
        background-color: #2B2B2B;
        padding-top: 15px;
        border-top: 1px solid #948c8c;
    }

    .footer .v-menu .v-list__tile__title {
        font-size: 13px !important;
        border: 1px solid #948c8c;
        text-align: center;
        padding: 0px 20px 0px 10px;
        background-color: #020381;
        color: #fff;
        height: 30px;
        line-height: 30px;
    }

    .border .theme--dark.v-text-field > .v-input__control > .v-input__slot:before,
    .border .theme--dark.v-text-field > .v-input__control > .v-input__slot:hover:before,
    .theme--dark.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {
        border: none !important;
    }
    /*
        Betslip IE

    */
    _:-ms-fullscreen, :root .border .v-text-field__slot input:disabled {
        margin-top: 5px;
        max-height: 25px;
    }

    @media screen and (min-width:0\0) and (min-resolution: +72dpi) {
        .border .v-text-field__slot input:disabled {
            margin-top: 5px;
            max-height: 25px;
        }
    }
    /* IOS FIX */
    @supports (-webkit-touch-callout: none) {
        .odd {
            top: 0 !important;
        }

        @media (max-width: 1024px) {
            .odd {
                top: 0 !important;
            }
        }
    }

    @supports (-webkit-overflow-scrolling: touch) {
        .odd {
            top: 0 !important;
        }

        @media (max-width: 1024px) {
            .odd {
                top: 0 !important;
            }
        }
    }
    /* @ End IOS FIX */
    /* Hide numbers arrows on Stake */
    /* Chrome, Safari, Edge, Opera */
    .v-text-field__slot input::-webkit-outer-spin-button,
    .v-text-field__slot input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    .v-text-field__slot input[type=number] {
        -moz-appearance: textfield;
    }
    /* @ End Hide numbers arrows on Stake */
</style>
